<template>
  <el-card>
    <template v-slot:header>
      <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Adjacent genes and Non-adjacent genes</span>
        <el-button type="primary" icon="el-icon-download" size="small" @click="downloadChart('png')" style="float: right;">Download PNG</el-button>
        <el-button type="primary" icon="el-icon-download" size="small" @click="downloadChart('svg')" style="float: right;margin-right: 5px;">Download SVG</el-button>
      </div>
    </template>
    <div class="container">
      <el-container>
          <el-main>
              <div id="boxplot" style="width:100%;height:500px;"></div>
          </el-main>
      </el-container>
    </div>  
  </el-card>
</template>
  
  <script>
  export default {
    props: {
      species: {
        type: String,
        required: true
      },
      tissue: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        chartData: [],//存放图表数据
        url: "http://183.175.59.4/devenhancer/",// 后端接口地址
        }
    },
    mounted() {
      this.$nextTick(() => {
        this.handleSearch();
      });
    },
    methods: {
      handleSearch() {
      const params = {
        Species: this.species,
        Type: this.tissue
      }
      this.$axios.get(this.url + "adgene" + "/", { params }).then(res => {
        const data = res.data
        if (data && Array.isArray(data) && data.length > 0) {
          // 定义变量存放x轴类目和两组数据
          let adjacentData = []
          let nonAdjacentData = []
          for (let gene of data) {
            //根据Sample分别将数据加入相应的数据数组中
            if (gene.Sample === 'adjacent') {
              adjacentData.push(gene.TPM.trim())
            } else if (gene.Sample === 'non-adjacent') {
              nonAdjacentData.push(gene.TPM.trim())
            }
          }
          //将数据组装成seriesData所需的格式
          const seriesData = [{
            name: 'adjacent',
            type: 'boxplot',
            data: adjacentData,
            tooltip: { formatter: '{b}: {c}' } // 格式化 tooltip
          }, {
            name: 'non-adjacent',
            type: 'boxplot',
            data: nonAdjacentData,
            tooltip: { formatter: '{b}: {c}' } // 格式化 tooltip
          }]
          this.chartData = seriesData
          const chart = this.$echarts.init(document.getElementById('boxplot'))
          let boxplotData  = seriesData.map(item => {
            let data = item.data.sort((a, b) => a - b); // 将数据排序
            let q1Index = Math.floor(data.length / 4); // 找到 Q1 点的位置
            let q3Index = Math.ceil(data.length * 3 / 4); // 找到 Q3 点的位置
            let min = data[0];
            let max = data[data.length - 1];
            let median = data[Math.floor(data.length / 2)];
            let q1 = data[q1Index];
            let q3 = data[q3Index];
            return [min, q1, median, q3, max]; // 返回盒图所需的五个数据点
            });
          chart.setOption({
            // title: { text: 'Gene Expression', left: 'center' },//图的标题
            tooltip: {},//鼠标悬停时显示的提示框
            grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },//直角坐标系内绘图网格，控制图表的大小和布局
            xAxis: { type: 'category', data: ['adjacent', 'non-adjacent'] },//直角坐标系 X 轴，
            yAxis: { //直角坐标系 Y 轴
                type: 'value',
                name: 'TPM',
              },
            legend: {//图例
              top: 'top',
              left: 'right'
            },
            series: [{
              type: 'boxplot',
              data: boxplotData,
              tooltip: {
                formatter: function (param) {
                    return [
                          param.name + ': ',
                        'upper: ' + param.data[4],
                        'Q3: ' + param.data[3],
                        'median: ' + param.data[2],
                        'Q1: ' + param.data[1],
                        'lower: ' + param.data[0]
                    ].join('<br/>')
                }
              },
              itemStyle: {
                color: '#72d4e0', // 设置箱线图的颜色
                borderColor: '#000000' // 设置边框颜色
              },
            }],//系列列表，指定图表中的数据信息
          })
        } else {
          this.$message.warning('No data found.')
        }
      }).catch(err => {
        console.error(err)
        this.$message.error('Failed to fetch data.')
      })
      },
      // 下载图表
      downloadChart(format) {
        const options = {
        type: format,
        pixelRatio: 2,
        backgroundColor: '#fff',
        };
        const imageData = this.$echarts.init(document.getElementById('boxplot')).getDataURL(options);
        // 创建 a 标签并设置属性
        const link = document.createElement('a');
        link.href = imageData;
        link.download = `se_ad.${format}`;
        // 触发下载
        link.click();
      },
    }
  }   
  </script>
  
  <style>
  .el-header {
    height: 80px;
    border-bottom: 1px solid #eee;
  }
  </style>


// WEBPACK FOOTER //
// src/components/seAnalysis/Seadgene.vue